export enum SuspendedReason {
    LOSS = 'LOSS',
    NONPAYMENT = 'NONPAYMENT',
    PRESAR = 'PRESAR',
    THEFT = 'THEFT',
}
